import {Analytics, GTag, GTagEventObserver, GTagEventData, GTagPageviewObserver} from '@plaudit/analytics';
import FacebookPixel from "@plaudit/analytics/dist/tracker/FacebookPixel";
import MicrosoftUniversalEventTracking from "@plaudit/analytics/dist/tracker/MicrosoftUniversalEventTracking";

Analytics.setup({features: {errorTracking: false}});


const gtag = GTag.getInstance();
const facebookPixel = FacebookPixel.getInstance();
const msTracking = MicrosoftUniversalEventTracking.getInstance();

if (gtag !== null) {
	gtag.addObserver(
		
		new GTagPageviewObserver(
			{
				pagePath: (value: string) => {
					return value === "/buyer-designation-application-success"
						|| value === "/contact-success"
						|| value === "/questionnaire-success"
						|| value === "/consultation-success"
				}
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({ value: 500 });
			}
		)
	);
	
	gtag.addObserver(
		new GTagEventObserver(
			{
				// Email or Telephone Click
				eventCategory: (value: string) => value === "Email Link" || value === "Telephone Link",
				eventAction: (value: string) => value === "Click"
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({ value: 250 });
			},
		)
	);

	gtag.addObserver(
		new GTagEventObserver(
			true,
            (tracker: GTag, data: GTagEventData) => {
                if (data.eventParams !== undefined) {
                    if (msTracking !== null) msTracking.trackEvent(
						data.eventParams.event_category,
						data.eventName,
						data.eventParams.event_label,
						data.eventParams.value,
						data.eventParams.non_interaction
					);
                }
            }
		)
	);
}
